import React from 'react'
import { string, func } from 'prop-types'

const TextArea = ({
  label,
  value,
  onChange,
  id,
  maxLength,
  error,
}) => (
  <div className="text-area">
    {label ? <label htmlFor={id}>{label}</label> : null}
    <textarea id={id} rows="4" cols="50" value={value} onChange={onChange} maxLength={maxLength} />
    { error ? <div className="input-error" role="alert">{error}</div> : null }
  </div>
)

TextArea.propTypes = {
  label: string,
  value: string.isRequired,
  onChange: func.isRequired,
  id: string,
  maxLength: string,
  error: string,
}

TextArea.defaultProps = {
  label: '',
  id: null,
  maxLength: '',
  error: '',
}

export default TextArea

